export const FETCH_TOKEN = 'views/users/FETCH_TOKEN'
export const FETCH_SECOND_TOKEN = 'views/users/FETCH_SECOND_TOKEN'